import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1b9b0da8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "bg-yellow-bar text-gray-800 p-2 font-semibold m-2 text-md flex justify-between items-center" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("You are viewing this game in <span class=\"xr-test-net h6\" data-v-1b9b0da8><span class=\"path1\" data-v-1b9b0da8></span><span class=\"path2\" data-v-1b9b0da8></span><span class=\"path3\" data-v-1b9b0da8></span><span class=\"path4\" data-v-1b9b0da8></span></span>", 2)
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Close Preview")
const _hoisted_5 = {
  key: 1,
  class: "cover-img p-0 m-2 block overflow-hidden"
}
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "bg-black-body m-2" }
const _hoisted_8 = { class: "md:grid md:grid-cols-3 game-details text-white p-5 pt-7 border-bottom-theme" }
const _hoisted_9 = { class: "col-span-2" }
const _hoisted_10 = { class: "text-white text-4xl mb-4 font-semibold" }
const _hoisted_11 = { class: "m-0 text-sm flex items-center" }
const _hoisted_12 = /*#__PURE__*/_createTextVNode("By: ")
const _hoisted_13 = { class: "text-blue-primary" }
const _hoisted_14 = { class: "text-gray-text flex items-center" }
const _hoisted_15 = /*#__PURE__*/_createTextVNode("Browser ")
const _hoisted_16 = { class: "text-gray-text flex items-center" }
const _hoisted_17 = {
  key: 0,
  class: "text-gray-text flex items-center"
}
const _hoisted_18 = /*#__PURE__*/_createTextVNode("Share with Friends ")
const _hoisted_19 = {
  key: 1,
  class: "text-gray-text"
}
const _hoisted_20 = {
  key: 2,
  class: "text-gray-text"
}
const _hoisted_21 = { class: "game-details text-white p-3 md:grid md:grid-cols-3 px-5" }
const _hoisted_22 = { class: "md:col-span-2 md:pr-3" }
const _hoisted_23 = { class: "description" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "About this Game", -1))
const _hoisted_25 = ["innerHTML"]
const _hoisted_26 = {
  key: 1,
  class: "text-gray-text",
  style: {"margin-bottom":"10px"}
}
const _hoisted_27 = {
  key: 2,
  class: "pt-2"
}
const _hoisted_28 = {
  key: 3,
  class: "p-0 text-gray-text"
}
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", null, "Scary Bears and Cute Visuals", -1))
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", null, "Endless Gameplay", -1))
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", null, "Easy Controls", -1))
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("a", {
    class: "text yellow-bar",
    "data-bs-toggle": "modal",
    "data-bs-target": "#popupLeavingXarcade",
    id: "btnpopupLeavingXarcade"
  }, "https://mygamerwebsite.com")
], -1))
const _hoisted_33 = [
  _hoisted_29,
  _hoisted_30,
  _hoisted_31,
  _hoisted_32
]
const _hoisted_34 = { class: "col-md-4 right-column" }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "pb-3 border-bottom-theme text-2xl font-semibold" }, "Game Details", -1))
const _hoisted_36 = { class: "md:grid md:grid-cols-2 py-3 border-bottom-theme text-sm" }
const _hoisted_37 = { class: "py-2" }
const _hoisted_38 = /*#__PURE__*/_createTextVNode("Game ID: ")
const _hoisted_39 = { class: "text-gray-text" }
const _hoisted_40 = {
  key: 0,
  class: "py-2"
}
const _hoisted_41 = /*#__PURE__*/_createTextVNode(" Last Update: ")
const _hoisted_42 = { class: "text-gray-text" }
const _hoisted_43 = { class: "py-2" }
const _hoisted_44 = /*#__PURE__*/_createTextVNode(" Content Rating: ")
const _hoisted_45 = { class: "text-gray-text" }
const _hoisted_46 = {
  key: 1,
  class: "py-2"
}
const _hoisted_47 = /*#__PURE__*/_createTextVNode(" Submission Date: ")
const _hoisted_48 = { class: "text-gray-text" }
const _hoisted_49 = {
  key: 2,
  class: "py-2"
}
const _hoisted_50 = /*#__PURE__*/_createTextVNode(" Played by: ")
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-gray-text" }, "12,225 users", -1))
const _hoisted_52 = [
  _hoisted_50,
  _hoisted_51
]
const _hoisted_53 = { class: "py-2" }
const _hoisted_54 = /*#__PURE__*/_createTextVNode(" Current Version: ")
const _hoisted_55 = { class: "text-gray-text" }
const _hoisted_56 = { class: "row gd-margin border-bottom-theme" }
const _hoisted_57 = { class: "col-md-6 py-2" }
const _hoisted_58 = /*#__PURE__*/_createTextVNode(" Developer: ")
const _hoisted_59 = { class: "text-blue-primary" }
const _hoisted_60 = {
  key: 0,
  class: "row gd-margin border-bottom-theme"
}
const _hoisted_61 = { class: "col-md-12 py-2" }
const _hoisted_62 = /*#__PURE__*/_createTextVNode(" Platform: ")
const _hoisted_63 = { class: "text-gray-text" }
const _hoisted_64 = /*#__PURE__*/_createTextVNode("Browser ")
const _hoisted_65 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-md-12 py-2" }, [
  /*#__PURE__*/_createTextVNode(" Compatible Browser: "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-blue-primary" }, "Chrome, Firefox, Safari, Opera, Edge")
], -1))
const _hoisted_66 = {
  key: 1,
  class: "row gd-margin border-bottom-theme"
}
const _hoisted_67 = { class: "col-md-12 py-2" }
const _hoisted_68 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Language:", -1))
const _hoisted_69 = { key: 0 }
const _hoisted_70 = { class: "text-blue-primary" }
const _hoisted_71 = {
  key: 2,
  class: "row gd-margin"
}
const _hoisted_72 = { class: "py-2" }
const _hoisted_73 = { key: 0 }
const _hoisted_74 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_GamesGalleryComponent = _resolveComponent("GamesGalleryComponent")!

  return (_openBlock(), _createElementBlock("main", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("span", null, [
        _hoisted_2,
        _createTextVNode(" " + _toDisplayString(_ctx.testnetLabel) + " Environment", 1)
      ]),
      _createVNode(_component_router_link, {
        to: { name: 'viewGamesUpdate', params: { gameId: _ctx.$route.params.gameId }},
        class: "text-xs text-gray-800 transition-all duration-200 hover:text-black-ori hover:underline"
      }, {
        default: _withCtx(() => [
          _hoisted_4
        ]),
        _: 1
      }, 8, ["to"])
    ]),
    (_ctx.coverImage)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "cover-img bg-gray-500 p-0 m-2 bg-blend-overlay",
          style: _normalizeStyle('background-image: url(' + _ctx.coverImage + '); background-repeat: no-repeat;')
        }, null, 4))
      : (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createElementVNode("img", {
            src: require('@/assets/images/default-cover.png')
          }, null, 8, _hoisted_6)
        ])),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.gameDetails.title), 1),
          _createElementVNode("ul", _hoisted_11, [
            _createElementVNode("li", null, [
              _hoisted_12,
              _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.username), 1)
            ]),
            _createElementVNode("li", _hoisted_14, [
              _hoisted_15,
              _createVNode(_component_font_awesome_icon, {
                icon: "fa-solid fa-earth-asia",
                class: "inline-block ml-1 text-sm relative"
              })
            ]),
            _createElementVNode("li", _hoisted_16, [
              _createTextVNode(_toDisplayString(_ctx.gameDetails.category) + " ", 1),
              _createVNode(_component_font_awesome_icon, {
                icon: "fa-solid fa-tree",
                class: "inline-block ml-1 text-sm relative"
              })
            ]),
            false
              ? (_openBlock(), _createElementBlock("li", _hoisted_17, [
                  _hoisted_18,
                  _createVNode(_component_font_awesome_icon, {
                    icon: "fa-solid fa-share",
                    class: "inline-block ml-1 text-sm relative"
                  })
                ]))
              : _createCommentVNode("", true),
            false
              ? (_openBlock(), _createElementBlock("li", _hoisted_19, [
                  _createVNode(_component_font_awesome_icon, {
                    icon: "fa-solid fa-heart",
                    class: "inline-block"
                  })
                ]))
              : _createCommentVNode("", true),
            false
              ? (_openBlock(), _createElementBlock("li", _hoisted_20, [
                  _createVNode(_component_font_awesome_icon, {
                    icon: "fa-solid fa-tag",
                    class: "inline-block"
                  })
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_21, [
        _createElementVNode("div", _hoisted_22, [
          _createVNode(_component_GamesGalleryComponent),
          _createElementVNode("div", _hoisted_23, [
            _hoisted_24,
            (_ctx.about)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: "text-gray-text",
                  style: {"margin-bottom":"10px"},
                  innerHTML: _ctx.about
                }, null, 8, _hoisted_25))
              : (_openBlock(), _createElementBlock("div", _hoisted_26, "-")),
            false
              ? (_openBlock(), _createElementBlock("h5", _hoisted_27, "Game Features"))
              : _createCommentVNode("", true),
            false
              ? (_openBlock(), _createElementBlock("ul", _hoisted_28, _hoisted_33))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", _hoisted_34, [
          _hoisted_35,
          _createElementVNode("div", _hoisted_36, [
            _createElementVNode("div", _hoisted_37, [
              _hoisted_38,
              _createElementVNode("span", _hoisted_39, _toDisplayString(_ctx.gameDetails.gameId), 1)
            ]),
            (_ctx.gameDetails.updated != _ctx.gameDetails.created && _ctx.gameDetails.updated != null)
              ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                  _hoisted_41,
                  _createElementVNode("span", _hoisted_42, _toDisplayString(_ctx.gameDetails.updated), 1)
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_43, [
              _hoisted_44,
              _createElementVNode("span", _hoisted_45, _toDisplayString(_ctx.gameDetails.contentRating?_ctx.gameDetails.contentRating:'-'), 1)
            ]),
            (_ctx.gameDetails.created)
              ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
                  _hoisted_47,
                  _createElementVNode("span", _hoisted_48, _toDisplayString(_ctx.gameDetails.created), 1)
                ]))
              : _createCommentVNode("", true),
            false
              ? (_openBlock(), _createElementBlock("div", _hoisted_49, _hoisted_52))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_53, [
              _hoisted_54,
              _createElementVNode("span", _hoisted_55, _toDisplayString(_ctx.gameDetails.version?_ctx.gameDetails.version:'-'), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_56, [
            _createElementVNode("div", _hoisted_57, [
              _hoisted_58,
              _createElementVNode("span", _hoisted_59, _toDisplayString(_ctx.username), 1)
            ])
          ]),
          false
            ? (_openBlock(), _createElementBlock("div", _hoisted_60, [
                _createElementVNode("div", _hoisted_61, [
                  _hoisted_62,
                  _createElementVNode("span", _hoisted_63, [
                    _hoisted_64,
                    _createVNode(_component_font_awesome_icon, { icon: "fa-solid fa-earth-asia" })
                  ])
                ]),
                _hoisted_65
              ]))
            : _createCommentVNode("", true),
          (_ctx.gameDetails.languages)
            ? (_openBlock(), _createElementBlock("div", _hoisted_66, [
                _createElementVNode("div", _hoisted_67, [
                  _hoisted_68,
                  (_ctx.gameDetails.languages.length == 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_69, " - "))
                    : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.gameDetails.languages, (language, index) => {
                        return (_openBlock(), _createElementBlock("div", {
                          class: "text-gray-text text-sm",
                          key: index
                        }, [
                          _createElementVNode("span", _hoisted_70, _toDisplayString(language.name), 1),
                          _createTextVNode(" - " + _toDisplayString(language.audio?'Audio':'') + _toDisplayString(language.interface?', Interface':'') + _toDisplayString(language.subtitles?', Subtitles':'') + " ", 1),
                          _createVNode(_component_font_awesome_icon, {
                            icon: "fa-solid fa-earth-asia",
                            class: "inline-block ml-1"
                          })
                        ]))
                      }), 128))
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.gameDetails.tags)
            ? (_openBlock(), _createElementBlock("div", _hoisted_71, [
                _createElementVNode("div", _hoisted_72, [
                  _createTextVNode(" Tag" + _toDisplayString(_ctx.gameDetails.tags.length > 1?'s':'') + ": ", 1),
                  (_ctx.gameDetails.tags.length > 0)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_73, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.gameDetails.tags, (tag, index) => {
                          return (_openBlock(), _createElementBlock("div", {
                            class: "inline-block my-1 mr-1 rounded-lg px-3 py-0.5 bg-blue-primary text-xs",
                            key: index
                          }, _toDisplayString(tag), 1))
                        }), 128))
                      ]))
                    : (_openBlock(), _createElementBlock("span", _hoisted_74, "-"))
                ])
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ]))
}